import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { HeaderTabs, OtherAccounts } from "../../components";
import { CardButton, PrimaryCard } from "../../components/Card";
import RecentTransactions from "../../components/RecentTranactions";
import ViewRecentTransaction from "../../components/RecentTranactions/partials/ViewRecentTransaction";
import { setActiveAccount } from "../../redux/actions/home/ActiveAccountAction";
import AddAccountModal from "../../components/Modals/AddAccount/AddAccountModal";
import {
  CardButtonSkeleton,
  OtherAccountsSkeletons,
  PrimaryCardSkeleton,
  RecentTransactionsSkeleton,
} from "../../components/Skeleton";
import ReccentTransactionSideBar from "../../components/Common/RecentTransactionsSideBar";
import EmptyCrypto from "../../components/Empty/EmptyCrypto";
import CustomTransition from "../../components/CustomTransition";
import { setPageTitle } from "../../helper/metaDataHelper";
import { getCryptoAccounts } from "../../redux/actions/CryptoTransaction/GetCryptoAccounts";
import { getModuleStatus } from "../../redux/actions/lookups/getModuleStatus";
import { getClientAccounts } from "../../redux/actions/home/ClientInfoAction";
import { useRecentTransaction } from "../../hooks/useRecentTransaction";
import TickerTapeWidget from "../../components/CryptoChart/TickerTapeWidget";
// import AdvancedChartWidget from "../../components/CryptoChart/AdvancedChartWidget";
import CryptocurrencyMarket from "../../components/CryptoChart/CryptocurrencyMarket";
import TopStories from "../../components/CryptoChart/TopStories";
import TechnicalAnalysis from "../../components/CryptoChart/TechnicalAnalysis";

const CryptoAdvance = () => {
  const [activeTransaction, setActiveTransaction] = useState(null);
  const [clientAccounts, setClientAccounts] = useState([]);
  const [ShowRecentTransaction, setShowRecentTransaction] = useState(false);
  const [clientAccountsLoading, setClientAccountsLoading] = useState(true);
  const { isLoading } = useSelector((state) => state.common);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { activeAccount } = useSelector((state) => state.activeAccount);
  const [recentTransactionsLoading, setRecentTransactionsLoading] =
    useState(false);
  const { lastThreeTransactions } = useRecentTransaction(
    setRecentTransactionsLoading,
    "account"
  );

  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    const handleThemeChange = () => {
      setTheme(localStorage.getItem("theme") || "light");
    };

    window.addEventListener("themeChanged", handleThemeChange);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("themeChanged", handleThemeChange);
    };
  }, []);

  useEffect(() => {
    setPageTitle("Crypto Advance");
  }, []);

  useEffect(() => {
    const getCryptoData = async () => {
      try {
        if (!user) {
          navigate("/signin");
        } else {
          setClientAccountsLoading(true);

          const [clientCryptoAccounts] = await Promise.all([
            dispatch(getCryptoAccounts()),
            dispatch(getModuleStatus({ modules: ["Bitpace", "Crypto"] })),
            dispatch(getClientAccounts()),
          ]);

          if (clientCryptoAccounts.length > 0) {
            setClientAccounts(clientCryptoAccounts);
            await dispatch(setActiveAccount(clientCryptoAccounts[0]));
          }
        }
      } catch (error) {
        console.error("Error in useEffect:", error);
      } finally {
        setClientAccountsLoading(false);
      }
    };

    getCryptoData();
    
    // eslint-disable-next-line
  }, [user, navigate]);

  return (
    <>
      <main>
        <div className="max-w-[1024px] mx-auto px-4 min-h-screen">
          <div className="flex flex-col">
            <HeaderTabs />
            <div className="w-full my-4">
              <TickerTapeWidget theme={theme} />
            </div>
            <div className="flex flex-col lg:flex-row md:flex-row gap-8 md:gap-4 justify-center">
              {/* First sections */}
              <div className="w-full lg:w-2/3 md:w-1/2 mb-6 lg:mb-0 md:mb-0 space-y-6">
                {isLoading || clientAccountsLoading ? (
                  <>
                    <PrimaryCardSkeleton count={5} />
                    <RecentTransactionsSkeleton />
                    <CardButtonSkeleton />
                  </>
                ) : clientAccounts && clientAccounts.length > 0 ? (
                  <>
                    {/* <div>
                      <AdvancedChartWidget
                        theme={theme}
                        activeAccount={activeAccount}
                      />
                    </div> */}
                    <PrimaryCard
                      clientAccounts={clientAccounts}
                      activeAccount={activeAccount}
                      type="crypto"
                      crypto={true}
                      theme={theme}
                      showChart={true}
                    />
                    {!recentTransactionsLoading ? (
                      <RecentTransactions
                        activeTransaction={activeTransaction}
                        transactions={lastThreeTransactions}
                        setActiveTransaction={setActiveTransaction}
                        setShowRecentTransaction={setShowRecentTransaction}
                        type="crypto"
                      />
                    ) : (
                      <RecentTransactionsSkeleton />
                    )}
                    <div className="md:hidden block">
                      <AddAccountModal>
                        <CardButton
                          title={"Add new account"}
                          subtitle={"Explore other currency in the world"}
                        />
                      </AddAccountModal>
                    </div>
                  </>
                ) : (
                  <EmptyCrypto />
                )}
              </div>
              {/* Second sections */}
              {isLoading || clientAccountsLoading ? (
                <div className="xl:w-[404px] w-[350px] hidden md:block md:w-1/2 mt-2 sticky top-6 self-start space-y-4">
                  <OtherAccountsSkeletons />
                  <CardButtonSkeleton />
                </div>
              ) : clientAccounts && clientAccounts.length > 0 ? (
                <div className="xl:w-[404px] w-[350px] md:block md:w-1/2 mt-2">
                  <div className="hidden md:block">
                    <CustomTransition show={ShowRecentTransaction}>
                      {ShowRecentTransaction && (
                        <>
                          <div className="view-recent-transaction-wrapper h-[700px]">
                            <ViewRecentTransaction
                              transaction={activeTransaction}
                              setShowRecentTransaction={
                                setShowRecentTransaction
                              }
                              ShowRecentTransaction={ShowRecentTransaction}
                              setActiveTransaction={setActiveTransaction}
                              type="crypto"
                            />
                          </div>
                        </>
                      )}
                    </CustomTransition>
                    <ReccentTransactionSideBar
                      ShowRecentTransaction={ShowRecentTransaction}
                      setShowRecentTransaction={setShowRecentTransaction}
                      activeTransaction={activeTransaction}
                      setActiveTransaction={setActiveTransaction}
                      type="crypto"
                    />

                    <CustomTransition show={!ShowRecentTransaction}>
                      {!ShowRecentTransaction && (
                        <>
                          <OtherAccounts
                            clientAccounts={clientAccounts}
                            activeAccount={activeAccount}
                          />
                          <AddAccountModal crypto={true}>
                            <CardButton
                              title={"Add new account"}
                              subtitle={"Explore other currency in the world"}
                            />
                          </AddAccountModal>
                        </>
                      )}
                    </CustomTransition>
                  </div>

                  <div className="mt-4">
                    <TechnicalAnalysis
                      activeAccount={activeAccount}
                      theme={theme}
                    />
                  </div>

                  <div className="mt-4">
                    <TopStories theme={theme} />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="mt-8 hidden md:block">
              <h2 className="text-2xl font-bold text-text-primary mb-4">
                Cryptocurrency Market
              </h2>
              <div>
                <CryptocurrencyMarket theme={theme} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default CryptoAdvance;
